import * as THREE from "three";
import { World } from "./World";
import {
    vDefaultShader, fBasicHatchingShader,
    vOgreWaterShader, fOgreWaterShader,
    vSkyOgreShader, fSkyOgreShader
} from '../shaders/';

import { ParticlesSystem } from "../components/ParticlesSystem";

export class OgreWorld extends World {
    constructor({ name, model, assets }) {
        super({ name, model, assets })
        this.camera.near = .1
        this.camera.far = 100
        this.titleBrightness = .1
        this.titleDisplace = .35
        this.titleScale = .8
    }

    processModel() {
        super.processModel();

        const basicMat = new THREE.ShaderMaterial({
            uniforms: {
                map: { value: null },
                hatchingScale: { value: 20 },
                hatchingMap: { value: this.assets.textures.hatchC },
                gamma: { value: 1.7 },
                mixDiffuse: { value: 0 },
                whiteLevel: { value: 1.2 },
                blackLevel: { value: -.07 },
                time: { value: 0 },
            },
            vertexShader: vDefaultShader,
            fragmentShader: fBasicHatchingShader,
        })

        const skyMat = new THREE.ShaderMaterial({
            uniforms: {
                map: { value: this.mapSky },
                noiseMap: { value: this.assets.textures.noise },
                hatchingScale: { value: 10 },
                hatchingMap: { value: this.assets.textures.hatchC },
                mixDiffuse: { value: 0 },
                gamma: { value: 2.2 },
                whiteLevel: { value: 1.4 },
                blackLevel: { value: -.1 },
                time: { value: 0 },
            },
            vertexShader: vSkyOgreShader,
            fragmentShader: fSkyOgreShader,
        })

        const waterMat = new THREE.ShaderMaterial({
            uniforms: {
                map: { value: null },
                noiseMap: { value: this.assets.textures.noise },
                hatchingScale: { value: 5 },
                hatchingMap: { value: this.assets.textures.hatchC },
                gamma: { value: 2 },
                mixDiffuse: { value: 0 },
                whiteLevel: { value: 1 },
                blackLevel: { value: 0 },
                time: { value: 0 },
            },
            vertexShader: vOgreWaterShader,
            fragmentShader: fOgreWaterShader,
            transparent: true,
        })

        this.island = this.model.scene.getObjectByName("Island");
        const islandMat = basicMat.clone()
        islandMat.uniforms.map.value = this.island.material.map
        islandMat.uniforms.hatchingScale.value = 10
        this.island.material = islandMat

        this.rocksAndTrees = this.model.scene.getObjectByName("rocksAndTrees");
        const rocksAndTreesMat = basicMat.clone()
        rocksAndTreesMat.uniforms.map.value = this.rocksAndTrees.material.map
        rocksAndTreesMat.uniforms.hatchingScale.value = 10
        this.rocksAndTrees.material = rocksAndTreesMat

        this.characters = this.model.scene.getObjectByName("characters");
        const charactersMat = basicMat.clone()
        charactersMat.uniforms.map.value = this.characters.material.map
        charactersMat.uniforms.hatchingScale.value = 10
        this.characters.material = charactersMat

        this.smallStones = this.model.scene.getObjectByName("smallStones");
        const smallStonesMat = basicMat.clone()
        smallStonesMat.uniforms.map.value = this.smallStones.material.map
        smallStonesMat.uniforms.hatchingScale.value = 10
        this.smallStones.material = smallStonesMat

        this.waterSurface = this.model.scene.getObjectByName("waterSurface");
        const waterSurfaceMat = waterMat
        waterSurfaceMat.uniforms.map.value = this.waterSurface.material.map
        this.waterSurface.material = waterSurfaceMat

        this.sky = this.model.scene.getObjectByName("sky");
        skyMat.uniforms.map.value = this.sky.material.map
        this.sky.material = skyMat

        // LEAF
        this.leaf = this.model.scene.getObjectByName('leaf')

        this.emitter = this.model.scene.getObjectByName("emitter1");
        this.ps = new ParticlesSystem({
            scene: this.scene,
            emitter: this.emitter,
            particle: this.leaf,
            count: 50,
            particleLife: 5,
            particleMaxDelay: 3,
            particleScale: new THREE.Vector3(3, 3, 3),
            particleScaleVariation: new THREE.Vector3(1, 1, 1),
            particleScaleSpeed: new THREE.Vector3(-.6, -.6, -.6),
            particleScaleSpeedVariation: new THREE.Vector3(.1, .1, .1),
            followNormal: true,
            normalVariation: new THREE.Vector3(0, 0, 0),
            particleTransSpeed: 2,
            particleTransVariation: .2,
            particleRotSpeed: new THREE.Vector3(2, .1, .1),
        })
        this.ps.createParticles()

    }

    loop({ time, deltaTime }) {
        super.loop({ time, deltaTime });

        if (this.waterSurface) {
            this.waterSurface.material.uniforms.time.value = time;
        }
        if (this.sky) {
            this.sky.material.uniforms.time.value = time;
        }
        this.ps.updateParticles(deltaTime)
    }
}